
import { useFormik } from "formik";
// import { useContext } from "react";
// import UserContext from '../utils/UserContext';
import { Link, useNavigate} from "react-router-dom";
// import { createUserWithEmailAndPassword} from "firebase/auth";
// import {auth} from '../utils/firebase'
import {signUp} from "../utils/authHelper"


const SignUp = () => {
  // const {setUser} = useContext(UserContext);

  const navigate = useNavigate();

  //Creating user with email & password
  // const signUp = async (email, password) => {
  //   try{
  //     await createUserWithEmailAndPassword(auth, email, password);
  //     navigate("/login");
  //   }
  //   catch(error){
  //     console.log(error);
  //   }
  // }

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validate: (values) => {
      const errors = {};

      if (!values.email) {
        errors.email = "Required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }

      if (!values.password) {
        errors.password = "Required";
      } else if (values.password.length < 8) {
        errors.password = "Must be 8 characters or more";
      }

      return errors;
    },

    onSubmit: async (values) => {
      //Comes in as JS object
      // console.log(values);
      // alert(JSON.stringify(values, null, 2));
      // setUser({name: values.username, email: values.email});
      await signUp(values.email, values.password);
      navigate("/");
    },
  });

  return (
    <div className="grow flex flex-col-reverse justify-center sm:flex-row">
      <img
        className="h-96 mt-6 sm:h-auto sm:mt-0"
        src="https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
      />

      <form
        className="flex flex-col justify-center px-6 sm:grow lg:w-1/3 lg:grow-0 xl:w-1/4"
        onSubmit={formik.handleSubmit}
      >
        <h3 className="text-4xl my-8 text-slate-800">Sign Up</h3>

        <div className="flex flex-col mb-2">
          <label htmlFor="email" className="font-medium text-slate-800">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            onChange={formik.handleChange}
            value={formik.values.email}
            onBlur={formik.handleBlur}
            className="shadow-md rounded-sm focus:outline-none p-1 text-slate-700"
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="text-xs font-medium text-red-500">
              {formik.errors.email}
            </div>
          ) : null}
        </div>

        <div className="flex flex-col mb-2">
          <label htmlFor="password" className="font-medium text-slate-800">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            onChange={formik.handleChange}
            value={formik.values.password}
            onBlur={formik.handleBlur}
            className="shadow-md rounded-sm focus:outline-none p-1 text-slate-700"
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="text-xs font-medium text-red-500">
              {formik.errors.password}
            </div>
          ) : null}
        </div>

        <button
          className="shadow-md rounded-full my-4 py-2 font-medium text-slate-800 hover:text-cyan-500"
          type="submit"
        >
          Sign Up
        </button>

        <h6 className="text-sm font-semibold text-center mt-2">
          Already have an account?{" "}
          <span className="text-cyan-500">
            <Link to="/login">Login</Link>
          </span>
        </h6>
      </form>
    </div>
  );
};

export default SignUp;
